














































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import KriteriaIcuSvc from "@/services/KriteriaIcuService";

@Component({
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class KriteriaIcuKeluarSection extends Vue {
  @Prop() data!: any;
  @Prop() register!: string | number;
  @Prop() rm!: string | number;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get isKeluarLocked(): boolean {
    return this.data?.is_keluar_locked || false;
  }

  get kriteriaCheckedCount(): number {
    return Object.keys(this.defaultForm()).filter(
      k => (k.startsWith("cl_") || k.startsWith("kk_")) && this.form[k] === true
    ).length;
  }

  get validationError(): string {
    if (this.isKeluarLocked) return "";
    if (this.kriteriaCheckedCount === 0) return "Minimal 1 kriteria keluar harus dicentang";
    return "";
  }

  form: any = this.defaultForm();
  saving = false;

  signDialog = false;
  signRole = "keluar-dpjp";
  signPassword = "";
  showPassword = false;
  signError = "";
  signing = false;

  defaultForm() {
    return {
      //  I. Kriteria Umum
      cl_hemodinamik_24jam: false,
      cl_spo2_stabil: false,
      cl_kesadaran_stabil: false,
      cl_no_monitoring_kontinu: false,
      cl_no_resusitasi_24jam: false,
      cl_no_syringe_pump: false,
      //  II. Kriteria Spesifik
      kk_vt_adekuat: false,
      kk_rr_normal: false,
      kk_agd_normal: false,
      kk_spo2_gt95: false,
      kk_batuk_adekuat: false,
      kk_hr_normal: false,
      kk_td_normal: false,
      kk_map_normal: false,
      kk_non_inotropic: false,
      kk_akral_hangat: false,
      kk_urine_adekuat: false,
      kk_elektrolit_normal: false,
      kk_cvp_normal: false,
      kk_gcs_gt12: false,
      kk_tidak_kejang: false,
      kk_suhu_normal: false,
      kk_gdr_normal: false,
      kk_insulin_non_iv: false,
    };
  }

  @Watch("data", { immediate: true })
  onDataChange() {
    if (this.data) this.populateForm();
  }

  populateForm() {
    const d = this.data;
    Object.keys(this.form).forEach(key => {
      if (d[key] !== undefined && d[key] !== null) {
        this.form[key] = d[key];
      }
    });
  }

  async save() {
    if (!this.data?.id) return;
    this.saving = true;
    try {
      const payload = { ...this.data, ...this.form };
      const resp = await KriteriaIcuSvc.update(this.data.id, payload);
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay("Berhasil menyimpan kriteria keluar ICU");
        this.$emit("saved", resp.data.data);
      }
    } catch (e) {
      // handled by service
    }
    this.saving = false;
  }

  openSign(role: string) {
    this.signRole = role;
    this.signPassword = "";
    this.signError = "";
    this.signDialog = true;
  }

  async doSign() {
    if (!this.signPassword) {
      this.signError = "Password harus diisi";
      return;
    }
    this.signing = true;
    this.signError = "";
    try {
      if (!this.isKeluarLocked) {
        await KriteriaIcuSvc.update(this.data.id, { ...this.data, ...this.form });
      }
      const payload = { password: this.signPassword };
      const resp =
        this.signRole === "keluar-dpjp"
          ? await KriteriaIcuSvc.signKeluarDpjp(this.data.id, payload)
          : await KriteriaIcuSvc.signKeluarPpja(this.data.id, payload);
      if (resp?.data?.status === "1") {
        appModule.NoticeDelay(resp.data.message || "Berhasil menandatangani");
        this.signDialog = false;
        this.$emit("saved", { id: this.data.id });
      }
    } catch (e) {
      this.signError = "Gagal menandatangani. Periksa password Anda.";
    }
    this.signing = false;
  }
}
